import LegalPageLayout from '../../components/LegalPageLayout';

export default function TermsOfServicePage() {
  return (
    <LegalPageLayout
      title="Terms of Service | EvidentTrail"
      description="EvidentTrail Terms of Service. Read the terms governing your use of our read-only compliance and audit evidence service."
    >
      <h1 className="text-3xl sm:text-4xl font-bold text-white mb-2">Terms of Service (Early Access)</h1>
      <p className="text-slate-400 mb-8">Effective date: January 2026</p>

      <h2 className="text-xl sm:text-2xl font-semibold text-white mt-10 mb-4">Early Access</h2>
      <p className="text-slate-300 leading-relaxed">
        EvidentTrail is offered on an early access basis. Features may change, and the service is provided 
        "as is" and "as available" during early access.
      </p>

      <h2 className="text-xl sm:text-2xl font-semibold text-white mt-10 mb-4">Use of the service</h2>
      <ul className="list-disc list-inside text-slate-300 space-y-2 ml-4">
        <li>You must have authority to connect your organization's repositories and systems.</li>
        <li>You are responsible for user access within your tenant and for maintaining appropriate internal policies.</li>
      </ul>

      <h2 className="text-xl sm:text-2xl font-semibold text-white mt-10 mb-4">Read-only nature</h2>
      <p className="text-slate-300 leading-relaxed">
        EvidentTrail is designed to be read-only and does not enforce workflows. You remain responsible 
        for your development and change management processes.
      </p>

      <h2 className="text-xl sm:text-2xl font-semibold text-white mt-10 mb-4">Accounts and security</h2>
      <p className="text-slate-300 leading-relaxed">
        You are responsible for safeguarding credentials and for actions taken under your account.
      </p>

      <h2 className="text-xl sm:text-2xl font-semibold text-white mt-10 mb-4">Data and permissions</h2>
      <p className="text-slate-300 leading-relaxed">
        You grant us permission to process connected-system data solely to provide the service. 
        You retain ownership of your data.
      </p>

      <h2 className="text-xl sm:text-2xl font-semibold text-white mt-10 mb-4">Subscription and billing (if applicable)</h2>
      <p className="text-slate-300 leading-relaxed">
        Paid plans may be offered. If you purchase a subscription, billing is handled by Stripe and 
        subject to plan limits, including repository limits and retention periods.
      </p>

      <h2 className="text-xl sm:text-2xl font-semibold text-white mt-10 mb-4">Acceptable use</h2>
      <p className="text-slate-300 leading-relaxed">
        You agree not to misuse the service, attempt unauthorized access, disrupt operations, or violate applicable laws.
      </p>

      <h2 className="text-xl sm:text-2xl font-semibold text-white mt-10 mb-4">Disclaimer</h2>
      <p className="text-slate-300 leading-relaxed">
        We do not warrant that the service will be uninterrupted or error-free. We do not guarantee that 
        using the service will achieve any specific audit or certification outcome.
      </p>

      <h2 className="text-xl sm:text-2xl font-semibold text-white mt-10 mb-4">Limitation of liability</h2>
      <p className="text-slate-300 leading-relaxed">
        To the maximum extent permitted by law, EvidentTrail will not be liable for indirect, incidental, 
        or consequential damages.
      </p>

      <h2 className="text-xl sm:text-2xl font-semibold text-white mt-10 mb-4">Termination</h2>
      <p className="text-slate-300 leading-relaxed">
        You may stop using the service at any time. We may suspend access to protect the service or if 
        required by law or non-payment (if applicable).
      </p>

      <h2 className="text-xl sm:text-2xl font-semibold text-white mt-10 mb-4">Changes</h2>
      <p className="text-slate-300 leading-relaxed">
        We may update these terms. Continued use after changes means you accept the updated terms.
      </p>

      <h2 className="text-xl sm:text-2xl font-semibold text-white mt-10 mb-4">Contact</h2>
      <p className="text-slate-300 leading-relaxed">
        <a href="/#contact" className="text-primary-400 hover:text-primary-300">
          Get in touch
        </a>{' '}through our contact form.
      </p>
    </LegalPageLayout>
  );
}
